import DocumentDetail from "../../documents/document-detail/DocumentDetail";

export default function ViewDocumentPage() {
  return <DocumentDetail />;
}
